<!DOCTYPE html>
@if (prizeList) {
  <div class="modal-container">
    <div class="modal-card">
      <ng-lottie [options]="prizeBox_anim" width="350px" class="main-prize" [ngClass]="{'jiggle': !matrixAnimation}"
      (animationCreated)="animationCreated($event)"></ng-lottie>
      <img class="mini-prize" (click)="playAnim()" src="../../../assets/icon/mini-prizes.png" alt="prizeBox" />
    </div>
    <div class="modal-content">
      <h2 class="opening" [ngClass]="{'come-out': matrixAnimation}">
      {{'game_details_page.prize_box_opening_popup_opening' | translate}}</h2>
      <div class="modal-header " [ngClass]="{'fade-away' : matrixAnimation}">
        <h2>{{'game_details_page.prize_box_opening_popup_title' | translate}}</h2>
        <p>{{'game_details_page.prize_box_opening_popup_sub_title' | translate}}</p>
      </div>
      @if (!animationComplete) {
        <div class="modal-body">
          <mat-grid-list [ngClass]="{'gridList' : matrixAnimation}" cols="3">
            @for (prizeLists of prizeList; track prizeLists; let i = $index) {
              <mat-grid-tile>
                <div class="prize-img">
                  <div [ngClass]="matrixAnimation ? 'claim-prize' + i : ''">
                    <img class="prize-list" [src]="prizeLists?.image_url" alt="fortune" />
                    <span class="prize-value">{{prizeLists?.convertedValue || prizeLists?.value}}</span>
                  </div>
                </div>
              </mat-grid-tile>
            }
          </mat-grid-list>
        </div>
      }
      <!-- Claimed Prize -->
      @if (animationComplete && claimedPrizeOrder !== undefined) {
        <div class="modal-body-prize">
          <p class="prize-value">{{'game_details_page.prize_box_opening_popup_you_won' | translate}}</p>
          <img [src]="claimedPrizeData?.image_url" class="claimed-prize" alt="claimed-prize" />
          <p class="prize-value">{{claimedPrizeData?.convertedValue || claimedPrizeData?.value}}</p>
          <button type="button" class="btn btn-light"
          (click)="close()">{{'game_details_page.prize_box_opening_popup_claim' | translate}}</button>
        </div>
      }
    </div>
  </div>
}
